import { COPY_ICON, TONE_ICON } from './laws'
import type { Tone } from './spec/types'

/**
 * The handful of things every block needs, in one place.
 *
 * Transcribed from the prototype's `ico`, `money` and the source-badge branch
 * of its block projector.
 *
 * Note what is NOT here: an `<Amount>` component. The guide sizes an amount
 * differently in every block that shows one — 21px/800 in the balance legs,
 * 12.5px/600 in a table cell, 15px/800 in the composer preview — and wrapping
 * that in one component with three size props would quietly invite a fourth
 * size that the design never specified. Each block renders its own markup and
 * shares only the formatter.
 */

/**
 * A tone's severity glyph, or nothing for a tone that has none.
 *
 * Neutral is deliberately unmarked: if every row had an icon, an icon would
 * stop meaning "read this one".
 */
export function ToneIcon({
  tone,
  size = 13,
  width = 2.2,
}: {
  tone: Tone | undefined
  size?: number
  width?: number
}) {
  const paths = tone === undefined ? undefined : TONE_ICON[tone]
  if (paths === undefined) return null
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={width}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flex: '0 0 auto' }}
      aria-hidden="true"
    >
      {paths.map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  )
}

/** The copy affordance beside a monospace identifier. */
export function CopyGlyph() {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flex: '0 0 auto', color: 'var(--k-mut2)', cursor: 'copy' }}
    >
      <title>Copy</title>
      <path d={COPY_ICON[0]} />
      <path d={COPY_ICON[1]} />
    </svg>
  )
}

